import React from 'react';

import { ArtifactType } from '@/models/Solicitacao';

import { Container, Heading } from './styles';
import LabelTipoSolicitacao from '../LabelTipoSolicitacao';

interface Props extends React.PropsWithChildren {
  tipo: ArtifactType;
  renderHeading?: () => React.ReactNode;
}

const SolicitacaoListContainer: React.FC<Props> = ({
  tipo,
  renderHeading,
  children,
}) => {
  return (
    <Container>
      {renderHeading ? (
        renderHeading()
      ) : (
        <Heading>
          <LabelTipoSolicitacao tipo={tipo} />
        </Heading>
      )}
      {children}
    </Container>
  );
};

export default SolicitacaoListContainer;
